import { ComponentType } from "react";
import DateField from "pages/common/Analytics/components/Reports/components/ReportForm/components/DateField/DateField";
import MultiselectField from "pages/common/Analytics/components/Reports/components/ReportForm/components/MultiselectField/MultiselectField";
import FreightModeField from "pages/common/Analytics/components/Reports/components/ReportForm/components/FreightModeField/FreightModeField";
import { IntlShape } from "react-intl";
import ReportType from "../../ReportType";

interface ReportField {
  component: ComponentType<any>; // ComponentType for the React component
  props?: Record<string, any>; // Optional props for the component
}

type ReportFields = {
  [key in ReportType]?: ReportField[];
};

const PROVIDER_REPORT_FIELDS = (intl: IntlShape, teams: any, shippers: any): ReportFields => ({
  [ReportType.SHIPMENTS]: [
    { component: DateField, props: { useGroupBy: true } },
    {
      component: MultiselectField,
      props: {
        name: "teams",
        label: intl.formatMessage({ id: "general.teams", defaultMessage: "Teams" }),
        description: intl.formatMessage({ id: "report.chooseTeamNames", defaultMessage: "Choose team names" }),
        options: teams,
        minSelected: 1,
      },
    },
    {
      component: MultiselectField,
      props: {
        name: "shippers",
        label: intl.formatMessage({ id: "general.shippers", defaultMessage: "Shippers" }),
        description: intl.formatMessage({ id: "report.chooseIncludedShippers", defaultMessage: "Choose included shippers" }),
        options: shippers,
        minSelected: 1,
      },
    },
    { component: FreightModeField, props: { minSelected: 1 } },
  ],
  [ReportType.QUOTES]: [
    { component: DateField },
    {
      component: MultiselectField,
      props: {
        name: "teams",
        label: intl.formatMessage({ id: "general.teams", defaultMessage: "Teams" }),
        description: intl.formatMessage({ id: "report.chooseTeamNames", defaultMessage: "Choose team names" }),
        options: teams,
        minSelected: 1,
      },
    },
    {
      component: MultiselectField,
      props: {
        name: "shippers",
        label: intl.formatMessage({ id: "general.shippers", defaultMessage: "Shippers" }),
        description: intl.formatMessage({ id: "report.chooseIncludedShippers", defaultMessage: "Choose included shippers" }),
        options: shippers,
        minSelected: 1,
      },
    },
    { component: FreightModeField, props: { minSelected: 1 } },
  ],
  [ReportType.INVOICES]: [
    { component: DateField, props: { useGroupBy: true } },
    {
      component: MultiselectField,
      props: {
        name: "teams",
        label: intl.formatMessage({ id: "general.teams", defaultMessage: "Teams" }),
        description: intl.formatMessage({ id: "report.chooseTeamNames", defaultMessage: "Choose team names" }),
        options: teams,
        minSelected: 1,
      },
    },
    { component: FreightModeField, props: { minSelected: 1 } },
  ],
});

export default PROVIDER_REPORT_FIELDS;
